"use client";

import { LABS } from "./registry";

/**
 * Ghi "behaviours chính" của learner trên lab về /api/lab/behaviour.
 * Bối cảnh (lab id / môn / level) tự suy ra từ URL + registry, nên nơi gọi
 * KHÔNG cần truyền context. Tự ẩn (no-op) ở hub, trang môn, trang non-lab.
 */

export type LabEvent = "lab_open" | "inquiry_open" | "inquiry_answer" | "lab_complete";

export function labContextFromPath(): { labId: string; subject: string; level: number } | null {
  if (typeof window === "undefined") return null;
  const m = window.location.pathname.match(/^\/lab\/([a-z0-9-]+)\/?$/i);
  if (!m || m[1] === "subject") return null;
  const lab = LABS.find((l) => l.id === m[1]);
  if (!lab) return null;
  return { labId: lab.id, subject: lab.subject, level: lab.level ?? 0 };
}

export function logLabEvent(event: LabEvent, payload?: Record<string, unknown>) {
  const ctx = labContextFromPath();
  if (!ctx) return;
  const body = JSON.stringify({ ...ctx, event, payload });
  try {
    // keepalive: gửi được cả khi trang đang rời đi. Cookie phiên gửi kèm tự động.
    void fetch("/api/lab/behaviour", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body,
      keepalive: true,
      cache: "no-store",
    }).catch(() => {});
  } catch {
    /* ignore */
  }
}
